export const LIBRARY_PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const;

export type LibraryPageSize = (typeof LIBRARY_PAGE_SIZE_OPTIONS)[number];

export const DEFAULT_LIBRARY_PAGE_SIZE: LibraryPageSize = 20;

export function parseLibraryPageSize(value: string | undefined): LibraryPageSize {
  const parsed = Number(value);

  if (LIBRARY_PAGE_SIZE_OPTIONS.includes(parsed as LibraryPageSize)) {
    return parsed as LibraryPageSize;
  }

  return DEFAULT_LIBRARY_PAGE_SIZE;
}

export function appendLibraryPageSizeParam(
  params: URLSearchParams,
  pageSize: number,
): void {
  if (pageSize !== DEFAULT_LIBRARY_PAGE_SIZE) {
    params.set("size", String(pageSize));
  }
}
